<client-adjustment-header
  *ngIf="projectContacts"
  [title]="'Te plaatsen'"
  [type]="'baseproject'"
  [currentCreatedAt]="
    baseProject.currentCreatedAt != null ? baseProject.currentCreatedAt : today
  "
  [projectContacts]="projectContacts"
  [extraCompanyContacts]="project.projectExtraCompanyContacts"
  [showTime]="project.id != null"
  [client]="client"
  [approved]="baseProject.approved"
  [approvedRegistration]="baseProject.approvedRegistration"
  [projectId]="project.id"
  [address]="baseProject.projectPlacement.address"
></client-adjustment-header>
<internal-info
  *ngIf="!client && !fromOldSystem"
  [subProject]="baseProject"
  (save)="save.emit(baseProject)"
></internal-info>

<ng-container *ngIf="firstProduct != null || project.products?.length > 0">
  <project-detail-card
    [cardType]="'configuration'"
    [products]="project.products"
    [firstProduct]="firstProduct != null ? firstProduct : project.products[0]"
    [project]="project"
    [projectPlacement]="baseProject.projectPlacement"
  ></project-detail-card>

  <client-sub-project-on-hold-collapse
    *ngIf="baseProject.putOnHold != null"
    [subProject]="baseProject"
    [onHoldCollapsed]="!baseProject.onHold"
    (save)="save.emit()"
  ></client-sub-project-on-hold-collapse>

  <project-detail-card
    [cardType]="'design'"
    [products]="firstProduct != null ? [firstProduct] : project.products"
    [assets]="designAssets"
    [ipBoardExamples]="ipBoardExamples"
    [project]="project"
    [fromOldSystem]="fromOldSystem"
  ></project-detail-card>

  <client-sub-project-design-collapse
    *ngIf="ipBoard != null && ipBoard.needsDesign"
    [project]="project"
    [baseProject]="baseProject"
    [ipBoard]="ipBoard"
    [designCollapsed]="ipBoard.designFinished"
    (save)="save.emit()"
  ></client-sub-project-design-collapse>

  <project-detail-card
    [cardType]="'placement'"
    [firstProduct]="firstProduct != null ? firstProduct : project.products[0]"
    [projectPlacement]="baseProject.projectPlacement"
    [baseProject]="baseProject"
    [project]="project"
    [assets]="placementAssets"
    [fromOldSystem]="fromOldSystem"
  ></project-detail-card>

  <sign-info-wrapper
    [client]="client"
    [ipBoard]="ipBoard"
    [infoType]="'immo'"
  ></sign-info-wrapper>

  <sign-info-wrapper
    [client]="client"
    [ipBoard]="ipBoard"
    [infoType]="'graphical'"
  ></sign-info-wrapper>

  <sign-info-wrapper
    [client]="client"
    [ipBoard]="ipBoard"
    [infoType]="'atelier'"
  ></sign-info-wrapper>

  <sign-info-wrapper
    [client]="client"
    [ipBoard]="ipBoard"
    [infoType]="'installer'"
  ></sign-info-wrapper>

  <project-detail-card
    *ngIf="
      client &&
      (project.id != null || baseProject.fromOldSystem) &&
      showExecutionInfo
    "
    [cardType]="'execution'"
    [products]="project.products"
    [baseProject]="baseProject"
    [project]="project"
    [assets]="executionAssets"
    [componentsExecuted]="componentsExecuted"
  ></project-detail-card>
</ng-container>

<appointment-collapse
  *ngIf="
    (project.id != null || !showExecutionInfo) &&
    (baseProject.projectPlacement.appointment ||
      baseProject.projectPlacement.collectKey ||
      baseProject.appointmentBlocksTourAssignment)
  "
  [project]="project"
  [subProject]="baseProject"
  [subProjectTitle]="subProjectTitle"
  [client]="client"
  (save)="save.emit()"
></appointment-collapse>

<execution-collapse
  *ngIf="project.id != null || !showExecutionInfo"
  [project]="project"
  [subProject]="baseProject"
  [subProjectTitle]="'Project'"
  [client]="client"
  [divergentPricesOnly]="divergentPricesOnly"
  (save)="save.emit()"
></execution-collapse>

<div
  *ngFor="
    let company of involvedCompanies;
    let first = first;
    let count = count;
    trackBy: trackById
  "
  [class.mt-3]="first"
>
  <project-detail-card
    *ngIf="!fromOldSystem && !baseProject.fromOldSystem"
    [cardType]="'facturation'"
    [project]="project"
    [baseProject]="baseProject"
    [company]="company"
    [alternativeTitle]="
      count > 1 && company.regularName?.length > 0
        ? company.regularName + ' preview'
        : ''
    "
    [outerTitle]="count > 1"
    [client]="client"
  ></project-detail-card>
</div>

<divergent-price-collapse
  *ngIf="project.id != null && !client && !baseProject.fromOldSystem"
  [baseProject]="baseProject"
  [subProject]="baseProject"
  [project]="project"
  [collaborative]="project.collaborative"
  (divergentPricesChecked)="divergentPricesOnly = $event"
  (save)="save.emit()"
></divergent-price-collapse>

<div class="actions-container">
  <client-detail-actions
    [subProject]="baseProject"
    [project]="project"
    [submitProjectResult]="submitProjectResult"
    [client]="client"
    (save)="save.emit()"
    (submitProject)="submitProject.emit()"
  ></client-detail-actions>
</div>
